import TailwindcssTypography from '@tailwindcss/typography';

/** @type {import('tailwindcss').Config} */
export default {
    content: [
      "./{pages,partials,layouts}/**/*.htm",
      "../../plugins/**/components/**/*.htm"
    ],
    theme: {
      container: {
        center: true,
        padding: '2rem'
      },
      fontFamily: {
        display: 'Inter, sans-serif',
        sans: 'Inter, sans-serif',
      },
      extend: {
        colors: {

          /* Color styles */
          'lime': {
            'DEFAULT': '#60f516',
          },

          'green': {
            'DEFAULT': '#4BA642', // 500
            'light': '#6FC167', // 400
            "50": "#F4FAF3",
            "100": "#E4F6E2",
            "200": "#CAEBC7",
            "300": "#A0DB9A",
            "400": "#6FC167",
            "500": "#4BA642",
            "600": "#398831",
            "700": "#306B2A",
            "800": "#285625",
            "900": "#224720",
            "950": "#0E260D",
          },
          'purple': {
            'DEFAULT': '#322354', // 950
            'light': '#48337c', // 900
            '50': '#efeffe',
            '100': '#e3e2fd',
            '200': '#cccafb',
            '300': '#afaaf7',
            '400': '#9888f1',
            '500': '#886ce8',
            '600': '#7a50db',
            '700': '#6a41c1',
            '800': '#56379c',
            '900': '#48337c',
            '950': '#322354',
          },
          'gray': {
            'DEFAULT': '#7a8599', // 700
            '50': '#f5f6f8',
            '100': '#ecf1f3',
            '200': '#dce5e9',
            '300': '#c7d2da',
            '400': '#afbdca',
            '500': '#9aa9ba',
            '600': '#8391a8',
            '700': '#7a8599',
            '800': '#5c6677',
            '900': '#4e5561',
            '950': '#2e3238',
          },
          'orange': {
            'DEFAULT': '#ff6536', // 400
            '50': '#fff3ed',
            '100': '#ffe4d4',
            '200': '#ffc4a8',
            '300': '#ff9b71',
            '400': '#ff6536',
            '500': '#fe3f11',
            '600': '#ef2507',
            '700': '#c61608',
            '800': '#9d140f',
            '900': '#7e1410',
            '950': '#440606',
          },
          'yellow': {
            'DEFAULT': '#ffaa00', // 500
            '50': '#fffdea',
            '100': '#fff6c5',
            '200': '#ffee85',
            '300': '#ffde46',
            '400': '#ffcc1b',
            '500': '#ffaa00',
            '600': '#e28100',
            '700': '#bb5902',
            '800': '#984508',
            '900': '#7c380b',
            '950': '#481c00',
          },
          'black' : '#1F143A'
        },
        typography: (theme) => ({
          DEFAULT: {
            css: {
              '--tw-prose-headings': theme('colors.purple.DEFAULT'),
              color: theme('colors.purple.DEFAULT'),
              a: {
                color: theme('colors.green.DEFAULT'),
                transition: 'color 0.3s',
                'text-decoration': 'none',
                '&:hover': {
                  color: theme('colors.green.light'),
                  'text-decoration': 'underline',
                },
              },
            }
          }
        })
      },
    },
    plugins: [TailwindcssTypography],
  }